import { render, staticRenderFns } from "./SpecialSpecialtyInfo.vue?vue&type=template&id=416a1a72&scoped=true&"
import script from "./SpecialSpecialtyInfo.vue?vue&type=script&lang=js&"
export * from "./SpecialSpecialtyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416a1a72",
  null
  
)

export default component.exports